import { render, staticRenderFns } from "./new_zone_management.vue?vue&type=template&id=71b3cfce"
import script from "./new_zone_management.vue?vue&type=script&lang=js"
export * from "./new_zone_management.vue?vue&type=script&lang=js"
import style0 from "./new_zone_management.vue?vue&type=style&index=0&id=71b3cfce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports